import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import Filters, { useUserStatesFilter } from "@/components/Elements/Filters";
import UserRolesList from "@/components/Elements/UserRolesList";
import UserState from "@/components/Elements/UserState";
import ListTable from "@/modules/list-table";
import {
  getTableFilterQueryable,
  TABLE_FILTER_TEXT,
} from "@/modules/table-filter";
import { format, fromNow } from "@/utilities/date";

const UsersTable = (listTableProps) => {
  const { t } = useTranslation();
  const userStatesFilter = useUserStatesFilter();

  const columns = [
    {
      title: t("global:name"),
      dataIndex: "name",
      render: (name, { id }) => <Link to={`/users/${id}`}>{name}</Link>,
      sorter: true,
      fixed: "left",
      minWidth: 220,
      ...TABLE_FILTER_TEXT,
    },
    {
      title: t("global:organization"),
      dataIndex: ["organization", "id"],
      render: (organization_id, { organization }) => (
        <Link to={`/organizations/${organization_id}`}>
          {organization?.name}
        </Link>
      ),
      sorter: true,
      sorterKey: "organization.name",
      ...getTableFilterQueryable({ model: "organizations" }),
    },
    {
      title: t("user:rolePlural"),
      dataIndex: ["roles", "id"],
      render: (id, { roles }) => <UserRolesList roles={roles} key={id} />,
      key: "roles.name",
      ...Filters.roles(),
    },
    {
      title: t("global:email"),
      dataIndex: "email",
      sorter: true,
      ...TABLE_FILTER_TEXT,
    },
    {
      title: t("global:status"),
      dataIndex: "state",
      render: (_, user) => <UserState user={user} />,
      sorter: true,
      ...userStatesFilter,
    },
    {
      title: t("user:stateUpdatedAt"),
      dataIndex: "state_updated_at",
      render: (value) => (
        <Tooltip title={format(value, "LLLL")}>{fromNow(value)}</Tooltip>
      ),
      sorter: true,
      ...Filters.dateRange,
    },
    {
      title: t("user:lastLoginAt"),
      dataIndex: "last_login_at",
      render: (value) => (
        <Tooltip title={format(value, "LLLL")}>{fromNow(value)}</Tooltip>
      ),
      sorter: true,
      ...Filters.dateRange,
    },
  ];

  return <ListTable columns={columns} {...listTableProps} />;
};

export default UsersTable;
